import { render, staticRenderFns } from "./wbdp-dailyData-list.vue?vue&type=template&id=647d432a"
import script from "./wbdp-dailyData-list.vue?vue&type=script&lang=js"
export * from "./wbdp-dailyData-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports